import { createRoot } from "react-dom/client";
import App from "./App";
import { hydrateAccountFromToken } from "./lib/store";
import "./index.css";

// Populate auth store from any existing JWT before first render so that
// ProtectedRoute doesn't flash a redirect to login on refresh.
hydrateAccountFromToken();

createRoot(document.getElementById("root")!).render(<App />);
